import { render, staticRenderFns } from "./ClassDocSearch.vue?vue&type=template&id=2b3d73f7&"
import script from "./ClassDocSearch.vue?vue&type=script&lang=js&"
export * from "./ClassDocSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports